import React from "react"
import { styled } from "styled-components"
import Button from "../Button"

const ButtonWithCaptionRoot = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`

const Caption = styled.div`
    font-size: 16px;
    font-weight: 500;
    padding: 10px 30px 10px 10px;
`

interface ButtonBarProps {
    id: string
    caption?: string
    buttonText: string
    onClick: () => void
    disabled: boolean
}

const ButtonWithCaption: React.FC<ButtonBarProps> = ({ id, caption, buttonText, onClick, disabled }) => {
    return (
        <ButtonWithCaptionRoot>
            {caption && <Caption>{caption}</Caption>}
            <Button id={id} caption={buttonText} inverse onClick={onClick} disabled={disabled} />
        </ButtonWithCaptionRoot>
    )
}

export default ButtonWithCaption
